import _axios from 'axios'
import cfg from './../config.js'

/*eslint-disable*/

let http = ({method, url}) => {
  return _axios[method](`${cfg.baseURL}/${url}`)
  .catch(function (error) {
    console.log(error);
  });
}

let api = {
  getDataForSoundMap: () => http({
    method: 'get',
    url: 'api/soundmap.json'
  }),
  getCompanies: () => http({
    method: 'get',
    url: 'api/companies.json'
  }),
  getCompany: (id) => http({
    method: 'get',
    url: `api/company/${id}.json`
  }),
  getPrograms: () => http({
    method: 'get',
    url: `api/programs.json`
  }),
  getDocs: () => http({
    method: 'get',
    url: `api/od-docs.json`
  }),
  getTeam: () => http({
    method: 'get',
    url: 'api/team.json'
  }),
  getOdNews: () => http({
    method: 'get',
    url: 'api/news-opendays.json'
  })
}
export default api
